"use client"

import Link from 'next/link'
import { WorkOrder } from '@/features/work-orders/types/work-order.type'

interface WorkOrderTimelineCardProps {
    workOrder: WorkOrder
}

export default function WorkOrderTimelineCard({ workOrder }: WorkOrderTimelineCardProps) {
    return (
        <Link
            href={`/work-orders/${workOrder.id}`}
            className="block"
        >
            <div className="border border-gray-300 rounded p-2 bg-gray-50 shadow-sm hover:shadow-md transition-shadow h-[120px] w-[120px] flex flex-col justify-center">
                <h5 className="text-xs font-semibold text-[#80A1B6] text-center mb-1">
                    Work Order:
                </h5>
                <p className="text-xs font-semibold text-[#80A1B6] text-center mb-2 break-words">
                    {workOrder.orderNumber || workOrder.id}
                </p>
                <p className="text-xs text-center text-gray-700 line-clamp-2">
                    {workOrder.workOrderType}
                </p>
            </div>
        </Link>
    )
}

